module.exports = __webpack_public_path__ + "static/media/summary-grey.2287a29c.svg";